<template>
  <div class="motto">
    <menuBox :step="2"></menuBox>
    <div class="motto-box">
      <p class="bt">รวมตัวกันและร่วมมือกันเพื่อสร้างอนาคตที่ดีกว่า</p>
      <span
        class="title">ทีมงานของเรามุ่งมั่นในการสร้างสรรค์นวัตกรรมและมุ่งมั่นที่จะนำเสนอโซลูชั่นที่ดีที่สุดให้กับลูกค้าของเรา</span>
      <div class="btn" @click="step">หน้าต่อไป</div>
    </div>
    <div class="stay-box">
      <div class="staty-left">
        <div class="bt">มารู้จักทีมงาน</div>
        <div class="title">มืออาชีพ·ความร่วมมือ·นวัตกรรม</div>
        <div class="text">ทีมงานของเรามุ่งมั่นที่จะบรรลุมูลค่าสูงสุดให้กับลูกค้าของเราด้วยความเชี่ยวชาญเชิงลึก
          จิตวิญญาณของการทำงานร่วมกันอย่างใกล้ชิด และแรงผลักดันสำหรับนวัตกรรมอย่างต่อเนื่อง</div>
        <ul>
          <li>
            <img src="../assets/check.png" alt="">
            <span>นวัตกรรม</span>
          </li>
          <li>
            <img src="../assets/check.png" alt="">
            <span>ความสามัคคี</span>
          </li>
          <li>
            <img src="../assets/check.png" alt="">
            <span>ประสิทธิภาพ</span>
          </li>
        </ul>
      </div>
      <img src="../assets/stay.png" class="stayImg" alt="">
    </div>
    <div class="clients-box">
      <div class="bt">รีวิวลูกค้า</div>
      <div class="clients-content">
        <img src="../assets/clientsImg.png" alt="" class="clientsImg">
        <div class="clients-right">
          <img src="../assets/quotation.png" alt="">
          <div class="title">บริษัท วิมุต แฟมิลี่ จำกัด ให้บริการโซลูชั่นทางการเงินที่ออกแบบโดยเฉพาะแก่ฉัน
            และฉันรู้สึกประทับใจในบริการระดับมืออาชีพและจิตวิญญาณแห่งนวัตกรรมของพวกเขา</div>
          <div class="yacob">— Somchai Srisawat</div>
          <div class="product">Product Manager, Qnet</div>
          <div class="list">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

    </div>
    <div class="blog-box">
      <div class="blog-top">
        <p>ข่าว</p>
        <!-- <span>All Articles →</span> -->
      </div>
      <div class="blogList">
        <div class="list">
          <img src="../assets/blog1.png" alt="">
          <p>WIMUT ส่งเสริมเทคโนโลยีทางการเงิน</p>
          <span>บริษัท วิมุต แฟมิลี่ จำกัด เพิ่งเปิดตัวแพลตฟอร์มเทคโนโลยีทางการเงินที่เป็นนวัตกรรมใหม่
            ซึ่งออกแบบมาเพื่อปรับปรุงประสิทธิภาพการจัดการทางการเงินของผู้ใช้ผ่านเครื่องมือวิเคราะห์ขั้นสูงและบริการเฉพาะบุคคล
            นี่เป็นก้าวสำคัญของบริษัทในด้านเทคโนโลยีทางการเงิน
          </span>
        </div>
        <div class="list">
          <img src="../assets/blog2.png" alt="">
          <p>บรรลุความร่วมมือเชิงกลยุทธ์ใหม่แล้ว</p>
          <span>บริษัท วิมุต แฟมิลี่ จำกัด ประกาศจัดตั้งพันธมิตรเชิงกลยุทธ์กับสถาบันการเงินที่มีชื่อเสียงระดับนานาชาติ
            เพื่อร่วมกันพัฒนาเครื่องมือและผลิตภัณฑ์การบริหารความมั่งคั่งใหม่ๆ
            ความเคลื่อนไหวนี้มีจุดมุ่งหมายเพื่อขยายขอบเขตการบริการ
            และเพิ่มความลึกและความกว้างของการจัดการสินทรัพย์ของลูกค้า</span>
        </div>
        <div class="list">
          <img src="../assets/blog3.png" alt="">
          <p>ผลตอบแทนที่ประสบความสำเร็จจากโครงการลงทุน</p>
          <span>บริษัท วิมุต แฟมิลี่ จำกัด ประสบความสำเร็จในการลงทุนโครงการใหญ่ ตอกย้ำผลตอบแทนที่คาดไว้ถึง 2 เท่า
            ความสำเร็จของโครงการนี้สะท้อนให้เห็นถึงความสามารถระดับมืออาชีพของ WIMUT
            และมุมมองเชิงคาดการณ์ล่วงหน้าในการจัดการสินทรัพย์และกลยุทธ์การลงทุน</span>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      val: ''
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "destination" });
    },
  },
};
</script>
<style lang="less" scoped>
.motto-box {
  background-image: url(../assets/about1.png);
  width: 100%;
  height: 750px;
  background-size: 100% 100%;
  padding: 180px 310px 0 310px;
  position: relative;
  box-sizing: border-box;

  .bt {
    max-width: 600px;
    margin-bottom: 35px;
    font-size: 58px;
    font-family: Roboto, Roboto;
    font-weight: 800;
    color: #FFFFFF;
  }

  .title {
    max-width: 600px;
    font-size: 20px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    color: #F4F4F4
  }

  .btn {
    display: table;
    cursor: pointer;
    margin-top: 60px;
    padding: 15px 36px;
    background: rgba(242, 102, 33, 1);
    border-radius: 37px;
    font-size: 16px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.stay-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 120px 310px;

  .staty-left {
    max-width: 550px;

    .bt {
      margin-bottom: 20px;
      font-size: 22px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #422535;
    }

    .title {
      margin-bottom: 20px;
      font-size: 69px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #422535;
    }

    .text {
      margin-bottom: 35px;
      font-size: 16px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: rgba(37, 43, 66, 0.6);
      line-height: 26px;
    }

    ul {
      li {
        display: flex;
        align-items: center;
        margin-bottom: 13px;

        img {
          margin-right: 17px;
          width: 29px;
          height: 29px;
        }

        span {
          font-size: 17px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #1A191E;
        }
      }
    }
  }

  .stayImg {
    width: 617px;
    height: 429px;
  }
}

.clients-box {
  padding: 60px 310px;
  background: #F8FBFF;

  .bt {
    margin: 0 auto 80px;
    max-width: 642px;
    font-size: 54px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    color: #252B42;
    text-align: center;
  }

  .clients-content {
    display: flex;
    justify-content: space-between;

    .clientsImg {
      margin-right: 110px;
      width: 453px;
      height: 334px;
    }

    .clients-right {
      img {
        margin-bottom: 36px;
        width: 51px;
        height: 38px;
      }

      .title {
        margin-bottom: 15px;
        font-size: 30px;
        font-family: Roboto, Roboto;
        font-weight: bold;
        color: #252B42;
      }

      .yacob {
        margin-bottom: 10px;
        font-size: 18px;
        font-family: Roboto, Roboto;
        font-weight: bold;
        color: #252B42;
      }

      .product {
        margin-bottom: 46px;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #757B8A;
      }

      .list {
        display: flex;

        span {
          margin-right: 12px;
          display: block;
          width: 12px;
          height: 12px;
          background: #D6DFDB;
          border-radius: 50%;
        }

        span:nth-child(1) {
          background: #F26621;
        }
      }
    }
  }
}

.blog-box {
  padding: 120px 310px;

  .blog-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      font-size: 54px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #252B42;
    }

    span {
      font-size: 18px;
      font-family: DM Sans, DM Sans;
      font-weight: 500;
      color: #00387A;
    }
  }

  .blogList {
    margin-top: 75px;
    display: flex;

    .list {
      display: flex;
      flex-direction: column;
      margin-right: 80px;

      img {
        margin-bottom: 24px;
        width: 378px;
        height: 378px;
      }

      p {
        max-width: 378px;
        margin-bottom: 10px;
        font-size: 28px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #1A191E;
        line-height: 34px;
      }

      span {
        max-width: 378px;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: rgba(37, 43, 66, 0.6);
        line-height: 26px;
      }
    }

    .list:nth-child(3) {
      margin-right: 0;
    }
  }
}</style>
